import { DataTestIds } from '@repo/frontend-shared';

import './Loader.scss';

interface LoaderProps {
  /** Overridable so a page with more than one spinner can tell them apart. */
  dataTestId?: string;
}

export function Loader({ dataTestId = DataTestIds.COMMON.CONTENT_AREA.RESOURCE_LOADER }: LoaderProps = {}) {
  return (
    <div className="Loader" data-testid={dataTestId}>
      <div className="Loader__spinner" />
    </div>
  );
}
